//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "quill/dist/quill.snow.css";
export default {
  props:{
    versiontype: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      text: "",
      completeLoading: false,
    };
  },
  methods: {
    async findPricyStatement() {
      let url = "api/api/findPrivacyStatement";
      let params = {
        'versiontype': this.versiontype
      };
      await this.axios
        .post(url, params)
        .then(({ data }) => {
          if (data.code == "1") {
            this.text = data.data.text;
            this.$emit("complete-loading");
          }
        })
        .catch((error) => console.log(error));
    },
  },
  created() {
    this.findPricyStatement();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/privacyPolicy.vue